import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { LightReachPricingResponse } from "../dto/light-reach.dto"
import { lightReachService } from "../services/light-reach.service"

export default function useFetchLightReachPricing(
  proposalId: string,
): UseQueryResult<LightReachPricingResponse, unknown> {
  const queryClient = useQueryClient()
  return useQuery({
    queryKey: queryKeys.lightReach.pricing(proposalId),
    queryFn: () => lightReachService.getPricingDetails(proposalId),
    enabled: !!proposalId,
    retry: 1, // Only retry once on failure
    onSuccess: () => {
      // Invalidate quotes queries when pricing data is successfully fetched
      queryClient.invalidateQueries({
        queryKey: queryKeys.lightReach.quote(proposalId),
        exact: false, // This will match all queries starting with this pattern
      })
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  })
}
